import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { UserContext } from "../context/UserContext";
import { useNavigate, Link } from "react-router-dom";
import "./Wishlist.css";

const Wishlist = () => {
  const { user } = useContext(UserContext);
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortOrder, setSortOrder] = useState("last-added"); // 🆕 Default

  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/login");
      return;
    }

    const fetchWishlist = async () => {
      try {
        const res = await axios.get(
          `https://bookmatchup.onrender.com/api/lists/wishlist/${user.id}`
        );
        setWishlist(res.data);
      } catch (err) {
        console.error("Error loading wishlist:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchWishlist();
  }, [user, navigate]);

  const handleDelete = async (itemId) => {
    if (!window.confirm("Remove this book from your wishlist?")) return;
    try {
      await axios.delete(
        `https://bookmatchup.onrender.com/api/lists/wishlist/${itemId}`
      );
      setWishlist((prev) => prev.filter((item) => item._id !== itemId));
    } catch (err) {
      console.error("Failed to delete item:", err);
    }
  };

  const handleAddToCompleted = async (wishlistItem) => {
    try {
      await axios.put(
        `https://bookmatchup.onrender.com/api/lists/wishlist-to-completed/${wishlistItem._id}`
      );
      setWishlist((prev) =>
        prev.filter((item) => item._id !== wishlistItem._id)
      );
      alert("Book moved to completed list!");
    } catch (err) {
      console.error("Error moving to completed:", err);
      alert("Failed to mark as completed");
    }
  };

  const sortWishlist = (list) => {
    switch (sortOrder) {
      case "first-added":
        return [...list]; // Normal oldest-first
      case "a-z":
        return [...list].sort((a, b) => {
          const titleA = a.bookId?.title?.toLowerCase() || "";
          const titleB = b.bookId?.title?.toLowerCase() || "";
          return titleA.localeCompare(titleB);
        });
      case "last-added":
      default:
        return [...list].reverse(); // 🔥 Newest first
    }
  };

  if (loading) return <p>Loading wishlist...</p>;

  const sortedWishlist = sortWishlist(wishlist);

  return (
    <div className="wishlist-container">
      <h2>Your Wishlist</h2>

      {/* 🆕 Sort Buttons */}
      <div className="sort-buttons-wrapper">
        <button
          className={`sort-button ${
            sortOrder === "last-added" ? "active" : ""
          }`}
          onClick={() => setSortOrder("last-added")}
        >
          Last Added
        </button>
        <button
          className={`sort-button ${
            sortOrder === "first-added" ? "active" : ""
          }`}
          onClick={() => setSortOrder("first-added")}
        >
          First Added
        </button>
        <button
          className={`sort-button ${sortOrder === "a-z" ? "active" : ""}`}
          onClick={() => setSortOrder("a-z")}
        >
          A to Z
        </button>
      </div>
      <p className="wishlist-note">Click a title to view book details.</p>
      {sortedWishlist.length === 0 ? (
        <p>No books in your wishlist yet.</p>
      ) : (
        <div className="wishlist-grid">
          {sortedWishlist.map((book) => (
            <div key={book._id} className="wishlist-card">
              {book.cover_url && (
                <img
                  src={book.cover_url}
                  alt="Book Cover"
                  className="wishlist-cover"
                />
              )}
              <div className="wishlist-details">
                <Link
                  to={`/book/${encodeURIComponent(book.bookId?.itemId || "")}`}
                  className="wishlist-title"
                >
                  {book.bookId?.title || "Untitled"}
                </Link>
                <p className="wishlist-author">
                  {book.author_name || "Unknown Author"}
                </p>
              </div>

              <div className="wishlist-actions">
                <button
                  className="button-danger"
                  onClick={() => handleDelete(book._id)}
                >
                  Remove
                </button>
                <button
                  className="button-style"
                  onClick={() => handleAddToCompleted(book)}
                >
                  Mark as Completed
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Wishlist;
